export default __webpack_public_path__ + "static/media/stepper-line-icon.0377dc4c.svg";